
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const Get_T_ELE_KPI_DumpData_SelectAPI = createAsyncThunk("Get_T_ELE_KPI_DumpData_Select", async ({ data }) => {
    const {
        T_ELE_KPI_DumpDataID,
        M_FinancialYearID,
        M_MonthID,
        M_ELEC_WorkID,
        M_WardID,
        M_Ward_Wise_VendorID,
        StartDay,
        EndDay,
        M_UserID,
        token,
        From,
        To,
        settableData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    url = `${BaseUrl}/Electrical/Get_T_ELE_KPI_DumpData_Select?T_ELE_KPI_DumpDataID=${T_ELE_KPI_DumpDataID}&M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ELEC_WorkID=${M_ELEC_WorkID}&M_WardID=${M_WardID}&M_Ward_Wise_VendorID=${M_Ward_Wise_VendorID}&StartDay=${StartDay}&EndDay=${EndDay}&M_UserID=${M_UserID}&From=${From}&To=${To}`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.length > 0) {
                settableData(result?.data)
                return result?.data
            } else {
                settableData([])
                return result
            }
        })
        .catch((err) => {
            settableData([])
            console.log("Error:", err)
            return err
        })
})

const Get_T_ELE_KPI_DumpData_SelectSlice = createSlice({
    name: "Get_T_ELE_KPI_DumpData_Select",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_T_ELE_KPI_DumpData_SelectAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_T_ELE_KPI_DumpData_SelectAPI.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.isLoading = false;
            state.tableData = data;

        });
        builder.addCase(Get_T_ELE_KPI_DumpData_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_T_ELE_KPI_DumpData_SelectReducer = Get_T_ELE_KPI_DumpData_SelectSlice.reducer


export const Post_T_ELE_KPI_DumpData_InsertDataAPI = createAsyncThunk("Post_T_ELE_KPI_DumpData_InsertData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        StartDay,
        EndDay,
        M_ELEC_WorkID,
        M_WardID,
        ReadingDate,
        MiniPillerNo,
        TotalOffTimeInHour,
        TotalOnTimeInHour,
        PillerIsOpen,
        PFOcuranceCount,
        ReadingTime,
        R_C,
        Y_C,
        B_C,
        CalCurrent,
        PillerCurrentAmps,
        M_Ward_Wise_VendorID,
        M_UserID,
        token,
        setLoading,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    formdata.append("M_FinancialYearID", M_FinancialYearID);
    formdata.append("M_MonthID", M_MonthID);
    formdata.append("StartDay", StartDay);
    formdata.append("EndDay", EndDay);
    formdata.append("M_ELEC_WorkID", M_ELEC_WorkID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("ReadingDate", ReadingDate);
    formdata.append("MiniPillerNo", MiniPillerNo);
    formdata.append("TotalOffTimeInHour", TotalOffTimeInHour);
    formdata.append("TotalOnTimeInHour", TotalOnTimeInHour);
    formdata.append("PillerIsOpen", PillerIsOpen);
    formdata.append("PFOcuranceCount", PFOcuranceCount);
    formdata.append("ReadingTime", ReadingTime);
    formdata.append("R_C", R_C);
    formdata.append("Y_C", Y_C);
    formdata.append("B_C", B_C);
    formdata.append("CalCurrent", CalCurrent);
    formdata.append("PillerCurrentAmps", PillerCurrentAmps);
    formdata.append("M_Ward_Wise_VendorID", M_Ward_Wise_VendorID);
    formdata.append("M_UserID", M_UserID);


    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)

    let url = `${BaseUrl}/DumpDataElec/Post_T_ELE_KPI_DumpData_Insert`

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                handleIsPost()
                // toastSuccesss(result.message)
                setLoading(false)
                return result
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const Post_T_ELE_KPI_DumpData_InsertDataSlice = createSlice({
    name: "Post_T_ELE_KPI_DumpData_InsertData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Post_T_ELE_KPI_DumpData_InsertDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Post_T_ELE_KPI_DumpData_InsertDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Post_T_ELE_KPI_DumpData_InsertDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const Post_T_ELE_KPI_DumpData_InsertDataReducer = Post_T_ELE_KPI_DumpData_InsertDataSlice.reducer